import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { withCookies, Cookies } from 'react-cookie'
import './Header.scss'

class HeaderLogin extends Component {
    render() {
        const appName = this.props.cookies.get('app_name')
        let topLogo = require('../../../Res/img/top_logo.png')
        if (appName && appName !== '') {
            topLogo = require(`../../../Res/3rd/${appName}/img/top_logo.png`)
        }
        return (
            <div>
                <div className="header_wrap">
                    <div className="bottom_wrap">
                        <div className="common_wrap">
                            <div className="logo login_no_logo">
                                <img src={topLogo} alt="HausPlanner" width="166" />
                            </div>
                            <div className="navi">
                                <div className="nav_login_no">
                                    {/* <Link to="/plan">설계</Link>
                  <div className="line" /> */}
                                    {/* <Link to="/magazine">매거진</Link>
                                    <div className="line" /> */}
                                    {/* <Link to="/seminar">교육</Link> */}
                                    {/* <div className="line" />
                                    <Link to="/bidding">견적요청</Link> */}
                                    {/* <div className="line mobile_v_impo" /> */}
                                    <Link className="join_btn" to="/login">
                                        로그인
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(HeaderLogin)



// WEBPACK FOOTER //
// ./Src/Components/Commons/HeaderLogin.js